import { render, staticRenderFns } from "./Indicacao.vue?vue&type=template&id=c4ea5182&scoped=true"
import script from "./Indicacao.vue?vue&type=script&lang=js"
export * from "./Indicacao.vue?vue&type=script&lang=js"
import style0 from "./Indicacao.vue?vue&type=style&index=0&id=c4ea5182&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ea5182",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VImg,VLayout,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ea5182')) {
      api.createRecord('c4ea5182', component.options)
    } else {
      api.reload('c4ea5182', component.options)
    }
    module.hot.accept("./Indicacao.vue?vue&type=template&id=c4ea5182&scoped=true", function () {
      api.rerender('c4ea5182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Indicacao.vue"
export default component.exports